"use client";

import styled from "styled-components";
import { spacing4, spacing8, spacing16, spacing24, spacing32, spacing48, spacing64, spacing128 } from "@churchofjesuschrist/eden-style-constants";
import { jsx as _jsx } from "react/jsx-runtime";
const gaps = {
  0: "0",
  4: spacing4,
  8: spacing8,
  16: spacing16,
  24: spacing24,
  32: spacing32,
  48: spacing48,
  64: spacing64,
  128: spacing128
};
const getRowGapSize = ({
  $rowGapSize,
  $gapSize
}) => {
  return gaps[$rowGapSize] || gaps[$gapSize];
};
const getColumnGapSize = ({
  $columnGapSize,
  $gapSize
}) => {
  return gaps[$columnGapSize] || gaps[$gapSize];
};
const flexNamesMap = {
  start: "flex-start",
  center: "center",
  end: "flex-end"
};
const JustifyContentMap = {
  ...flexNamesMap,
  "space-between": "space-between"
};
const Container = styled.div.withConfig({
  componentId: "sc-lf3bj0-0"
})(["display:flex;flex-wrap:wrap;gap:", " ", ";justify-content:", ";", ""], getRowGapSize, getColumnGapSize, ({
  $align
}) => JustifyContentMap[$align], ({
  $verticalAlign
}) => $verticalAlign ? `align-items: ${flexNamesMap[$verticalAlign]};` : "");

/**
 * Separates items with consistent spacing horizontally
 * @param {object} props - The component props
 * @param {"0" | "4" | "8" | "16" | "24" | "32" | "48" | "64" | "128"} [props.gapSize] - Gutter space between columns
 * @param {"0" | "4" | "8" | "16" | "24" | "32" | "48" | "64" | "128"} [props.columnGapSize] - Overrides gapSize for column gutter space only
 * @param {"0" | "4" | "8" | "16" | "24" | "32" | "48" | "64" | "128"} [props.rowGapSize] - Overrides gapSize for row gutter space only
 * @param {"start" | "center" | "end" | "space-between"} [props.align] - How to align the items horizontally in the row
 * @param {"start" | "center" | "end"} [props.verticalAlign] - How to align the items vertically in the row
 * @param {React.ReactNode} [props.children] - Row items
 * @returns {React.ReactElement} The Row component
 */
const Row = ({
  gapSize = "16",
  columnGapSize,
  rowGapSize,
  align = "start",
  verticalAlign,
  children,
  ...rest
}) => /*#__PURE__*/_jsx(Container, {
  $gapSize: gapSize,
  $columnGapSize: columnGapSize,
  $rowGapSize: rowGapSize,
  $align: align,
  $verticalAlign: verticalAlign,
  ...rest,
  children: children
});
Row.displayName = "Row";
export default Row;